import { render } from "./OrdererSelect.vue?vue&type=template&id=3ab5bfb0&scoped=true"
import script from "./OrdererSelect.vue?vue&type=script&lang=js"
export * from "./OrdererSelect.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=3ab5bfb0&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab5bfb0"]])

export default __exports__